<template>

  <t-page>

    <!--    <GroupProductDialog :no-option-add="noOptionAdd" @onSubmit="onGroupProductDialog"/>-->

    <t-page-form tabs :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmitDefault"
                 :submit-external="submitExternal"
                 :check-errors-again="checkErrorsComponent"
                 :set-tab-index="tabIndex"
                 :go-back-title="t('go-back-list')" :go-back-to="currentPage.name" :busy="!pageFormIsLoaded">

      <template #default="{status}">

        <t-input v-model="form[fieldKey]" hidden/>

        <t-form-tab title="Dados Básicos">

          <t-input v-model="form.groupProductId"
                   :options="groupProductOptions"
                   :add-error="error.groupProductId"
                   @change="changeGroupProduct"
                   label="Grupo de Produtos" required select>


          </t-input>

          <b-row>

            <t-input :label="'Cód. '+ accountPrefix" v-model="form.productCodeLabel"
                     :fixed-insert="groupProduct.codeGeneratorUsing" :add-error="error.productCodeLabel" cols="4" upper
                     :required="!groupProduct.codeGeneratorUsing"
                     :help="groupProduct.codeGeneratorUsing && command === 'insert' ? 'Cód. do Produto gerado automaticamente pelo sistema, porém poderá ser alterado após a inclusão, caso desejado' : ''"/>

            <b-col cols="8">

              <t-input v-if="groupProduct.nameGeneratorUsing && !form.forceNameManually"
                       label="Nome do Produto Automático" fixed
                       v-model="form.nameAutomatically"
                       help="Nome do produto será gerado automaticamente de acordo com os campos de medidas do grupo de produto."/>

              <t-input v-if="!groupProduct.nameGeneratorUsing || form.forceNameManually" label="Nome do Produto Manual"
                       v-model="form.nameManually" :add-error="error.nameManually" upper
                       required/>

              <b-form-checkbox switch v-if="groupProduct.nameGeneratorUsing" v-model="form.forceNameManually">
                Quebrar regra e utilizar nome manual?
                <t-help
                    title="Utilize esta opção somente se desejar que este produto especificamente o sistema não gere o nome manualmente. Caso for esta mesma regra em todos os produtos deste grupo, altere de forma geral no cadatro de grupos de produtos."/>
              </b-form-checkbox>

            </b-col>

          </b-row>

          <b-row>


            <div v-if="form.groupProductId > 0" class="col-6">

              <t-input v-model="form.modelId"
                       :options="modelOptions"
                       :add-error="error.modelId"
                       @change="getFieldsCustomizable('model')"
                       label="Modelo" required select/>
            </div>

            <t-input v-else value="-" cols="6"
                     label="Modelo" fixed><small>Selecione um grupo para listar os modelos</small></t-input>


            <t-input label="Un." cols="6" v-model="form.unitId" :options="unitOptions" select required/>

          </b-row>

          <b-row>

            <b-col cols="6">

              <t-input-code-label material @change="getCompoundsByMaterialId" v-model="form.materialId" required/>

            </b-col>


            <t-input label="Composto" cols="6" v-model="form.compoundId"
                     help="Compostos de acordo com o Material selecionado"
                     :options="compoundOptions" select required :disabled="form.materialId === 0"/>

          </b-row>


          <div class="mb-2 mt-4">

            <b-card-title>Exclusividade
              <t-help
                  title="Você poderá especificar que este produto é exclusivo apenas para um Cliente ou Grupo de Clientes."/>
            </b-card-title>

            <t-input v-model="form.typeExclusive"
                     label="Tipo de Exclusividade" hide-label :options="ProductExclusiveType.list" radio
                     required/>


            <t-input-person customer
                            v-if="form.typeExclusive === ProductExclusiveType.type.CUSTOMER" v-model="form.customerId"
                            required/>


            <t-input v-if="form.typeExclusive === ProductExclusiveType.type.GROUP_CUSTOMER"
                     v-model="form.customerGroupId"
                     label="Grupo de Cliente"
                     :options="groupCustomerOptions" required select/>

          </div>


          <div class="mb-2 mt-4">

            <b-card-title>Tipo do Produto</b-card-title>

            <t-input label="Tipo" hide-label @change="setTabKit" v-model="form.productType"
                     :options="ProductItemType.list"
                     first-default radio
                     required/>

          </div>

          <div class="mb-2 mt-4">

            <b-card-title>Outras específicações</b-card-title>

            Produto reprovado equivalente
            <t-help
                title="Utilizado em regras de fluxo de processos, onde é desejado substituir o produto da Ordem de Fabricação por motivo de reprovação."/>
            <t-input-product hide-label v-model="form.reprovedEquivalentProductId"/>

          </div>


          <t-page-form-field-customized
              ref="fieldsGeneral"
              :command="command" :status="status" :user-auth="userAuth"
              :fields-customizable="entityFieldCustomized('page')"
              :primary-key="form.productId" :foreign-key="currentPage.pageId" :busy="!pageFormIsLoaded"
              :primary-key-column="fieldKey" foreign-key-column="pageId"
          />

          <t-keyword v-model="form.keywords" class="mb-2"/>

          <t-input v-model="form.note" label="Observações" max-length="500" textarea/>

          <t-input-status v-model="form.status" class="mb-2"/>

        </t-form-tab>

        <t-form-tab title="Características" hash="detail">

          <t-msg v-if="form.groupProductId === 0" info>
            Selecione um grupo de produto na aba 'Dados Básicos' para
            especificar caracterísitcas
          </t-msg>

          <t-msg
              v-if="form.groupProductId > 0 &&
              complementList.length === 0 &&
              featureList.length === 0 &&
               entityFieldCustomized('groupProduct').length === 0 &&
               entityFieldCustomized('model').length === 0"
              info>
            Nenhum campo específico, acabamento ou característica vinculado ao grupo de produtos. Para preencher esta
            aba cadastre campos vinculados ao grupo/modelo e também cadastre Acabamentos e Características em 'Produtos'
            > 'Configurações'.
          </t-msg>

          <b-card-title
              v-if="entityFieldCustomized('groupProduct').length > 0 || entityFieldCustomized('model').length > 0">
            Medidas
          </b-card-title>

          <t-page-form-field-customized
              v-if="entityFieldCustomized('groupProduct').length > 0"
              :command="command" :status="status" :user-auth="userAuth"
              :fields-customizable="entityFieldCustomized('groupProduct')"
              :primary-key="form.productId" :foreign-key="form.groupProductId" :busy="!pageFormIsLoaded"
              primary-key-column="productId" foreign-key-column="groupProductId"
          />


          <t-page-form-field-customized
              v-if="entityFieldCustomized('model').length > 0"
              :command="command" :status="status" :user-auth="userAuth"
              :fields-customizable="entityFieldCustomized('model')"
              :primary-key="form.productId" :foreign-key="form.modelId" :busy="!pageFormIsLoaded"
              primary-key-column="productId" foreign-key-column="modelId"
          />

          <div v-if="complementList.length > 0" class="mt-3">
            <b-card-title>Acabamentos</b-card-title>

            <t-table
                enable-radio
                class="mb-2"
                v-model="form.complementId"
                :items="complementList"
                :fields="viewFieldsPageComplement"
                title-items="Acabamento"
                link-primary-column="name"
                table-bordered
                disable-actions-column
                primary-key-column="complementId">

              <template #first-column="{item}">
                {{ item.name }}
              </template>

            </t-table>
            <b-link v-if="form.complementId > 0" @click="form.complementId = 0" class="font-italic">Limpar Acabamento
            </b-link>

          </div>

          <div v-if="featureList.length > 0" class="mb-2 mt-4">

            <b-card-title>Detalhes</b-card-title>

            <t-table
                enable-checked
                v-model="form.featuresIds"
                :items="featureList"
                :fields="viewFieldsPageFeature"
                title-items="Características"
                link-primary-column="name"
                table-bordered
                disable-actions-column
                primary-key-column="featureId">

              <template #first-column="{item}">
                {{ item.name }}
              </template>

            </t-table>

          </div>

        </t-form-tab>

      </template>

      <template #out-of-form>

        <t-form-tab title="Itens do Kit" hash="kit" v-if="form.productType === ProductItemType.type.KIT"
                    :disabled="!relationAccessPageGeneral('product-item-kit')" lazy>
          <ProductKit :foreign-key="form.productId"/>
        </t-form-tab>


        <t-form-tab title="Conversão" hash="other-code"
                    :disabled="!relationAccessPageGeneral('product-item-other-code')" lazy>
          <ProductOtherCode :foreign-key="form.productId"/>
        </t-form-tab>

        <t-form-tab title="Moldes" hash="mold" :disabled="!relationAccessPageGeneral('product-item-mold')" lazy>
          <ProductMold :foreign-key="form.productId"/>
        </t-form-tab>

        <t-form-tab title="Especificações" hash="specification"
                    :disabled="!relationAccessPageGeneral('product-item-specification')" lazy>
          <ProductSpecification :foreign-key="form.productId"/>
        </t-form-tab>

        <t-form-tab title="Insumos" hash="supply" :disabled="!relationAccessPageGeneral('product-item-supply')" lazy>
          <ProductSupply :foreign-key="form.productId"/>
        </t-form-tab>

        <t-form-tab title="Imagens" hash="image" :disabled="!relationAccessPageGeneral('product-item-file')" lazy>
          <ProductFile :model-id="form.modelId" type-image :foreign-key="form[fieldKey]"/>
        </t-form-tab>

        <t-form-tab title="Arquivos" hash="file" :disabled="!relationAccessPageGeneral('product-item-file')" lazy>
          <ProductFile :model-id="form.modelId" :foreign-key="form[fieldKey]"/>
        </t-form-tab>

        <t-form-tab title="Comentários" hash="comment" :disabled="validationCommentOption === 0" lazy>
          <Comment :foreign-key="currentPage.pageId" :relation-key="form[fieldKey]"/>
        </t-form-tab>

        <t-form-tab title="Modificações" hash="log" lazy>
          <HistoryLog :pageId="currentPage.pageId" :relation-key="form[fieldKey]"/>
        </t-form-tab>

      </template>

    </t-page-form>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import modelService from "@/services/modules/product/Model.service"
import featureService from "@/services/modules/product/Feature.service";
import complementService from "@/services/modules/product/Complement.service";
import compoundService from "@/services/modules/product/Compound.service";
import http from "@/services/config/http-common";
import groupProductService from "@/services/modules/product/GroupProduct.service";
import pageViewService from "@/services/modules/setting/PageView.service";
import ProductItemType from "@/model/types/modules/product/ProductItemType";
import ProductExclusiveType from "@/model/types/modules/product/ProductExclusiveType";
import ui from "@/assets/scripts/ui";
import ProductFile from "@/views/modules/product/ProductFile";
import HistoryLog from "@/views/modules/general/HistoryLog";
import Comment from "@/views/modules/general/Comment";
import pageFormEmbeddableMixin from "@/mixins/page/pageFormEmbeddableMixin";
import ProductKit from "@/views/modules/product/ProductKit";
import ProductOtherCode from "@/views/modules/product/ProductOtherCode";
import ProductMold from "@/views/modules/product/ProductMold";
import ProductSpecification from "@/views/modules/product/ProductSpecification";
import ProductSupply from "@/views/modules/product/ProductSupply"
import TKeyword from "@/components/template/form/input/t-keyword";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormEmbeddableMixin],
  components: {
    ProductKit,
    ProductOtherCode,
    ProductMold,
    ProductSpecification,
    ProductSupply,
    ProductFile,
    HistoryLog,
    Comment,
    TKeyword
  },
  name: 'ProductFormProductionEmbeddable',
  data() {
    return {
      ProductItemType,
      ProductExclusiveType,
      ui,
      path: "product", //Utilizar somente quando fora do padrão
      genKey: true, //Utilizar quando desejar gerar chave temporária
      fieldKey: "productId",
      enableGeneralFields: true,
      /*FORM DECLARADO NO MIXIM PARA VIR DE FORA COM OS CAMPOS PADRÕES JUNTOS COM OS CUSTOMIZADOS*/
      error: {//Campos que podem receber retorno de erro do backend
        nameManually: "",
        groupProductId: "",
        productCodeLabel: "",
        modelId: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      tabIndex: 0,
      viewFieldsPageFeature: [],
      viewFieldsPageComplement: [],
      validationCommentOption: 0,
      accountPrefix: "",
      noOptionAdd: "",
      unitOptions: [],//ResponseSelect
      groupProductOptions: [],//ResponseSelect
      groupCustomerOptions: [],//ResponseSelect
      modelOptions: [],//ResponseSelect
      compoundOptions: [],//ResponseSelect
      //typeFeatureOptions: [],//ResponseSelect
      featureList: [],//Listagem completa
      complementList: [],//Listagem completa
      groupProduct: {
        groupProductId: 0,
        codeGeneratorUsing: false,
        nameGeneratorUsing: false,
      },//Detalhamento do grupo selecionado
      formOld: {//Armazena valores específicos que podem comprometer para poder retornar ao estado original
        groupProductId: 0,
        modelId: 0,
      },
      fieldsCustomizable: [
        {
          entity: "groupProduct",
          foreignKeyColumn: "groupProductId",
          path: "product/group-product",
          fields: [],
        },
        {
          entity: "model",
          foreignKeyColumn: "modelId",
          path: "product/model",
          fields: [],
        }
      ],
      //--------------------------------------------------------------------------------------
    }
  },
  computed: {},
  methods: {

    mountedPrepare() {

      this.mountedPrepareEmbeddable() //Sempre no início de mountedPrepare

      this.accountPrefix = ui.getAccountPrefix()


    },

    async mountedContinued() {

      this.validationCommentOption = this.getRenderRule('validationCommentOption')

      await http.list(this.path + "/selectRelationList").then((response) => {
        this.groupProductOptions = response.groupProductOptions
        this.unitOptions = response.unitOptions
        this.groupCustomerOptions = response.groupCustomerOptions

      }).catch(error => this.responseError(error))


      //Campos da Listagem de Características
      /*SEMPRE IRÁ VERIFICAR SE HOUVE OVERRIDE, POR TANTO ENVIAR A PÁGINA ORIGINAL*/
      await pageViewService.getViewFieldsByPage(156, true, ["groupsProduct"]).then((response) => {
        this.viewFieldsPageFeature = response
      }).catch(error => this.responseError(error))

      //Campos da Listagem de Acabamentos
      /*SEMPRE IRÁ VERIFICAR SE HOUVE OVERRIDE, POR TANTO ENVIAR A PÁGINA ORIGINAL*/
      await pageViewService.getViewFieldsByPage(157, true, ["groupsProduct"]).then((response) => {
        this.viewFieldsPageComplement = response
      }).catch(error => this.responseError(error))


      //Entidades condicionadas ao grupo de produtos
      await this.getEntitiesByGroupProductId()

      //Compostos relacionados ao Material
      await this.getCompoundsByMaterialId()

      this.mountedContinuedEmbeddable() //Sempre no final de mountedContinued


    },
    async onSubmit() {
      await this.setSendingDefault()
    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    /*onGroupProductDialog(itemInserted) {

      this.form.groupProductId = itemInserted.value
      this.groupProductOptions.find(group => group.groupId === itemInserted.groupId).options.push(itemInserted)

    },*/

    setTabKit() {


      if (this.pageFormIsLoaded) {

        if (this.form.productType === ProductItemType.type.KIT) {
          //Seta a guia do Kit para preenchimento
          setTimeout(() => {
            this.tabIndex = 2
          }, 100)
        }

      }


    },


    async getEntitiesByGroupProductId() {

      if (this.form.groupProductId > 0) {

        //a) Modelos
        await modelService.getModelsByGroupProductId(this.form.groupProductId).then((list) => {
          this.modelOptions = list
        }).catch(error => this.responseError(error))


        //b) Acabamentos (neste caso é a listagem completa e não somente responseSelect)
        await featureService.getFeaturesByGroupProductId(this.form.groupProductId).then((list) => {
          this.featureList = list
        }).catch(error => this.responseError(error))

        //c) Características (neste caso é a listagem completa e não somente responseSelect)
        await complementService.getComplementsByGroupProductId(this.form.groupProductId).then((list) => {
          this.complementList = list
        }).catch(error => this.responseError(error))

      }

    },

    async getCompoundsByMaterialId() {

      if (this.form.materialId > 0) {

        await compoundService.getCompoundsByMaterialId(this.form.materialId).then((list) => {
          this.compoundOptions = list
        }).catch(error => this.responseError(error))

      }

    },


    async getGroupProductDetail() {

      if (this.form.groupProductId > 0) {

        await groupProductService.getForceReadById(this.form.groupProductId).then((groupProduct) => {
          this.groupProduct = groupProduct
        }).catch(error => this.responseError(error))


      } else {
        this.groupProduct = { //Zera detalhe do grupo de produto atual
          groupProductId: 0,
          codeGeneratorUsing: false,
          nameGeneratorUsing: false,
        }
      }

    },

    async changeGroupProduct() {

      /*------------------------------------------------------------*/
      this.form.modelId = 0 //Zera para poder consistir o valor

      /*------------------------------------------------------------*/

      this.setBlackout(true)

      await this.getEntitiesByGroupProductId()
      await this.getFieldsCustomizable('groupProduct')
      await this.getGroupProductDetail()

      this.setBlackout(false)


    }
    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(true, false)

    await this.mountedContinued()

  },
  watch: {
    /*'form.productType': {
      handler: async function (after,before) {
        if (after !== undefined && after > 0 && after !== before){
          await this.setTabKit()
        }
      },
      deep: true
    }*/
  }

}
</script>